import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import CustomSelect from "../../component/CustomSelect";
import DynamicCKEditor from "../../component/DynamicCkEditor";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addEndpoint = ApiEndpoints.job.Create;
const locListEndpoint = ApiEndpoints.loc.List;
const depListEndpoint = ApiEndpoints.operation.List;
const expListEndpoint = ApiEndpoints.exp.List;

const userName = !localStorage.getItem("username") ? "Admin" : localStorage.getItem("username");

export default function AddJobPosting() {
  const navigate = useNavigate();

  const [dropData, setDropData] = useState({
    experiences: [],
    locations: [],
    departments: []
  });

  const [postData, setPostData] = useState({
    title: "",
    department_id: "",
    location_id: "",
    experience_id: "",
    type: "",
    date: new Date(),
    job_description: "",
    qualifications: "",
    skills: "",
    additional_information: "",
    slug: "",
    shift: "",
    brief_description: "",
    working_day: "",
  });

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [expRes, depRes, locRes] = await Promise.all([
          ApiRequest("GET", expListEndpoint),
          ApiRequest("GET", depListEndpoint),
          ApiRequest("GET", locListEndpoint),
        ]);

        setDropData({
          experiences: expRes?.experiences || [],
          departments: depRes?.departments || [],
          locations: locRes?.locations || [],
        });
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setDropData({ experiences: [], departments: [], locations: [] });
      }
    };

    fetchAll();
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setPostData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleEditorChange = (key, data) => {
    setPostData((prevState) => ({
      ...prevState,
      [key]: data,
    }));
  };


  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
      if (value === "" || value === null) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
      }
    }

    try {
      const response = await ApiRequest("POST", addEndpoint, postData);
      if (response.error !== true) {
        toast.success(response.message);
        navigate("/jobpost");
      } else {
        toast.error(response.message)
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / Job Posting / Add Job'
  }
  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form id="blogAdd" onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>title<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="title" value={postData.title} type="text" className="form-control" placeholder="Enter Title" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>slug<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="slug" value={postData.slug} type="text" className="form-control" placeholder="Enter Slug" />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Department<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} defaultValue={postData.department_id} name={"department_id"} options={dropData.departments} placeholder="Select Department" />
                </div>
              </div>


              {/* <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Job Type<small>*</small></label>
                  </div>
                  <input value={postData?.type} onChange={handleChange} name="type" type="text" className="form-control" placeholder="Enter Job Type" />
                </div>
              </div>  */}

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Working Days<small>*</small></label>
                  </div>
                  {/* <input value={postData?.working_day} onChange={handleChange} name="working_day" type="text" className="form-control" placeholder="Ex: monday to friday" /> */}

                  <CustomSelect onChange={handleChange} name={"working_day"} defaultValue={postData.working_day}
                    options={[{ _id: "Monday To Friday", name: "Monday To Friday" }, { _id: "Tuesday To Saturday", name: "Tuesday To Saturday" }, { _id: "Wednesday To Sunday", name: "Wednesday To Sunday" }]}
                    placeholder="Select Working Days " />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Shift<small>*</small></label>
                  </div>
                  {/* <input value={postData?.shift} onChange={handleChange} name="shift" type="text" className="form-control" placeholder="Ex: Day / Night" /> */}
                  <CustomSelect multiple onChange={handleChange} name={"shift"} defaultValue={postData.shift}
                    options={[{ _id: "Day Shift", name: "Day Shift" }, { _id: "Night Shift", name: "Night Shift" },  { _id: "Mid Shift", name: "Mid Shift" }, { _id: "Rotational Shift", name: "Rotational Shift" }]}
                    placeholder="Select Shift Type " />
                </div>
              </div>


              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Location<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"location_id"} defaultValue={postData.location_id} options={dropData.locations} placeholder="Select Location" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Experience<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"experience_id"} defaultValue={postData.experience_id} options={dropData.experiences} placeholder="Select Experience " />
                </div>
              </div>

              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Type<small>*</small></label>
                  </div>
                  <CustomSelect onChange={handleChange} name={"type"} defaultValue={postData.type}
                    options={[{ _id: "Full-Time", name: "Full-Time" }, { _id: "Part-Time", name: "Part-Time" }, { _id: "Internship", name: "Internship" }]}
                    placeholder="Select Type " />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Date<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="date" type="date" className="form-control" placeholder="select date" value={postData.date} />
                </div>
              </div>
            </div>
          </div>

          <div className="add-content-wrap">
            <div className="row">



              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Banner Description<small>*</small></label>
                  </div>
                  <input onChange={handleChange} name="brief_description" type="text" className="form-control" placeholder="Banner Description" value={postData.brief_description} />
                </div>
              </div>

              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Job Description<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.job_description} onChange={(event, editor) => handleEditorChange("job_description", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Qualifications<small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.qualifications} onChange={(event, editor) => handleEditorChange("qualifications", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Skills <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.skills} onChange={(event, editor) => handleEditorChange("skills", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label> Additional Information <small>*</small></label>
                  </div>
                  <DynamicCKEditor data={postData.additional_information} onChange={(event, editor) => handleEditorChange("additional_information", editor.getData())} />
                </div>
              </div>
            </div>
          </div>
        </form>
        <button type="submit" form="blogAdd" className="default-btn">publish <span></span></button>
      </div>
    </>
  );
}
